/**
 * UI-тексты VPN сервис-страницы (VpnPageContent).
 * Только вертикаль-специфика; общие надзаголовки/якоря/теги — в servicePage.
 * Интерполируемые строки — функции; склонение страны делает компонент и
 * передаёт сюда уже готовое слово (to).
 */
export const vpnPage = {
    en: {
        leaf: 'VPN',
        // Hero
        heroChoose: 'Choose a VPN',
        heroHow: 'How to install',
        // Anchors / eyebrows (vertical-specific)
        aboutAnchor: 'About VPN',
        servicesAnchor: 'Services',
        whyEyebrow: 'Why VPN',
        servicesEyebrow: 'Services',
        // Section titles (fallbacks when content.* is missing)
        whyTitle: 'What a VPN is and why you need one',
        benefitsTitle: 'Benefits of a VPN',
        instructionTitle: 'How to install a VPN',
        providersTitle: 'Verified VPN services',
        promosTitle: 'VPN promo codes',
        articlesTitle: 'VPN articles',
        // Leads
        promoLead: 'Current VPN discounts — tap “Show code” to copy.',
        articlesLead: 'How to choose and set up a VPN, bypass blocks and stay safe while travelling.',
        // Provider card actions
        visit: 'Visit →',
        // Bottom CTA
        ctaEyebrow: 'Open internet',
        ctaTitle: (to) => `Access your favourite services${to ? ` in ${to}` : ''}.`,
        ctaBtn: 'Choose a VPN →',
    },
    ru: {
        leaf: 'VPN',
        heroChoose: 'Выбрать VPN',
        heroHow: 'Как установить',
        aboutAnchor: 'О VPN',
        servicesAnchor: 'Сервисы',
        whyEyebrow: 'Для чего',
        servicesEyebrow: 'Сервисы',
        whyTitle: 'Что такое VPN и зачем он нужен',
        benefitsTitle: 'Преимущества VPN',
        instructionTitle: 'Как установить VPN',
        providersTitle: 'Проверенные VPN-сервисы',
        promosTitle: 'Промокоды на VPN',
        articlesTitle: 'Статьи о VPN',
        promoLead: 'Актуальные скидки от VPN-сервисов — нажмите «Показать код», чтобы скопировать.',
        articlesLead: 'Как выбрать и настроить VPN, обойти блокировки и оставаться в безопасности в поездке.',
        visit: 'Перейти →',
        ctaEyebrow: 'Свободный интернет',
        ctaTitle: (to) => `Доступ к любимым сервисам${to ? ` в ${to}` : ''}.`,
        ctaBtn: 'Выбрать VPN →',
    },
};
